import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card, CardBody, Button } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <main className="hn-payment-main">
        <Container className="py-5">
          <Card className="hn-payment-card">
            <CardBody className="text-center py-5">
              <h1 className="hn-payment-title mb-3">Checkout cancelled</h1>
              <p className="text-muted mb-4">
                No payment was made. You can try again anytime.
              </p>
              <Button color="secondary" outline className="me-2" onClick={() => navigate("/pricing")}>
                View plans
              </Button>
              <Button color="warning" onClick={() => navigate("/payment")}>
                Back to checkout
              </Button>
            </CardBody>
          </Card>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default PaymentCancelPage;

